'use client';

import React, { useState, useEffect } from 'react';
import { getLanguageFromBrowserCookies } from '@/lib/languageUtils';
import { LanguageType } from '@/lib/types';

const COOKIE_CONSENT_KEY = 'rivive_cookie_consent';

const CookieBanner: React.FC = () => {
	const [language, setLanguage] = useState<LanguageType>('english');
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		setLanguage(getLanguageFromBrowserCookies());
	}, []);

	useEffect(() => {
		// Check if user has already accepted cookies
		const hasConsented = localStorage.getItem(COOKIE_CONSENT_KEY);
		if (!hasConsented) {
			setIsVisible(true);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
		setIsVisible(false);
	};

	if (!isVisible) return null;

	return (
		<div
			className="
				fixed
				z-[9999]
				bottom-0
				left-1/2
				-translate-x-1/2
				w-[calc(100%-1.5rem)]
				max-w-[360px]
				tb:left-auto
				tb:translate-x-0
				tb:right-[3rem]
				tb:bottom-[3rem]
				tb:w-fit
				tb:max-w-none
			"
		>
			<div
				className="
					bg-bg-light-tertiary
					border-secondary
					border-stroke-soft-200
					border-b-transparent
					tb:border-b-stroke-soft-200
					rounded-tl-[20px]
					rounded-tr-[20px]
					tb:rounded-bl-[20px]
					tb:rounded-br-[20px]
					flex
					flex-col
					tb:flex-row
					items-center
					gap-[1rem]
					tb:gap-[2rem]
					py-[1.5rem]
					px-[2rem]
					tb:py-[0.75rem]
					tb:px-[1.5rem]
				"
			>
				<p className="
					text-16-fixed--alexandria
					text-text-tertiary
					whitespace-normal
					tb:whitespace-nowrap
					text-center
					tb:text-left
				">
					{language === 'arabic' ? 'يستخدم هذا الموقع ملفات تعريف الارتباط لتخصيص تجربتك' : 'This website uses cookies to personalize your journey.'}
				</p>

				<button
					onClick={handleAccept}
					className="
						w-full
						tb:w-auto
						text-16-fixed--alexandria
						text-text-tertiary
						bg-transparent
						border-[1.5px]
						border-stroke-soft-200
						rounded-[16px]
						py-[12px]
						px-[22px]
						cursor-pointer
						transition-colors
						duration-300
						hover:bg-bg-light-quaternary
						hover:border-stroke-sub-300
						whitespace-nowrap
					"
				>
					Okay
				</button>
			</div>
		</div>
	);
};

export default CookieBanner;
